export default __webpack_public_path__ + "static/media/News-min.440921d0.png";